var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-item"),
      _vm._v(" "),
      _c("sugg-item"),
      _vm._v(" "),
      _c("history-item"),
      _vm._v(" "),
      _c("hot-tab-item", { attrs: { "hot-list": _vm.item.hot } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }